import { render, staticRenderFns } from "./PortalRfxResponseSubmissionList.vue?vue&type=template&id=4b0505b0"
import script from "./PortalRfxResponseSubmissionList.vue?vue&type=script&lang=js"
export * from "./PortalRfxResponseSubmissionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports